import { styleIn } from "../../../../utils/styleOptions";
import { CONTAINER_NAME } from "../../../../utils/constant";
var setStorageSync = function setStorageSync(args) {
  args = styleIn(args, CONTAINER_NAME.KWAI);
  return ks.setStorageSync(args.key, args.data);
};
export default setStorageSync;